import React from 'react';
import { useIsMobile } from '../hooks/useIsMobile';

interface HeaderBarProps {
  title?: string;
  onBack?: () => void;
  rightContent?: React.ReactNode;
}

const HeaderBar: React.FC<HeaderBarProps> = ({ title, onBack, rightContent }) => {
  const isMobile = useIsMobile();

  return (
  <header
    style={{
      width: '100%',
      background: '#fff',
      boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
      height: 64,
      display: 'flex',
      alignItems: 'center',
      position: 'sticky',
      top: 0,
      zIndex: 10,
      marginBottom: 32,
    }}
  >
    <div style={{
      width: '100%',
      maxWidth: 1200,
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '100%',
      // Leave room on the left for the fixed mobile hamburger button.
      padding: isMobile ? '0 16px 0 68px' : '0 24px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        {onBack && (
          <button
            onClick={onBack}
            style={{
              background: 'none',
              border: 'none',
              fontSize: 24,
              cursor: 'pointer',
              color: '#38b2ac',
              marginRight: 8,
              padding: 0,
            }}
            aria-label="Back"
          >
            ←
          </button>
        )}
        {title && <span style={{ fontWeight: 700, fontSize: 22, color: '#222' }}>{title}</span>}
      </div>
      {rightContent && <div>{rightContent}</div>}
    </div>
  </header>
  );
};

export default HeaderBar;